<template>
  <div
    :class="$style.box"
    :style="{ backgroundImage: `url('${cdnUrl}/404-bg.jpg')` }"
  >
    <div :class="$style.scrollWrapper" ref="wrapper">
      <div :class="$style.tip">
        <img :src="`${cdnUrl}/404-icon.png`" alt="" />
        <img
          :src="`${cdnUrl}/404-${type == 1 ? 'start' : 'done'}.png`"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import BScroll from "@better-scroll/core";
import MouseWheel from "@better-scroll/mouse-wheel";

BScroll.use(MouseWheel);

export default {
  data() {
    return {
      cdnUrl: "//static.hzwxbz3.cn/Lianyun/font_end/ac",
      type: 0,
    };
  },
  mounted() {
    document.title = "活动维护中";
    this.type = this.$route.query.type;
    this.scrollInit();
  },
  methods: {
    scrollInit() {
      this.scroller = new BScroll(this.$refs.wrapper, {
        click: true,
        mouseWheel: {
          speed: 20,
          invert: false,
          easeTime: 300,
        },
        autoBlur: false,
        bounce: {
          top: false,
          bottom: false,
        },
      });
    },
  },
};
</script>

<style lang="scss" module>
.box {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-color: #32100e;
  .scrollWrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    .tip {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      top: 220px;
      > img:nth-child(1) {
        width: 100px;
        margin-bottom: 40px;
      }
      > img:nth-child(2) {
        width: 280px;
      }
    }
  }
}
</style>